module.exports = __webpack_public_path__ + "img/aftersell-submit-tips-cn.75cc160f.png";